import clsx from 'clsx';
import React from 'react';

interface Key {
  color: string;
  text: string;
}

const KEYS: Key[] = [
  {
    color: 'bg-primary-magenta/[0.15] dark:bg-primary-magenta/[0.35]',
    text: 'Before 2026',
  },
  {
    color: 'bg-secondary-brown-mid/[0.15] dark:bg-secondary-brown-mid/[0.35]',
    text: '2027 to 2030',
  },
  {
    color: 'bg-secondary-green-mid/[0.15] dark:bg-secondary-green-mid/[0.35]',
    text: 'Beyond 2030',
  },
];

const TableKey = (): JSX.Element => {
  return (
    <div className="my-24 flex w-fit flex-col items-start justify-start gap-24 bg-grayscale-beige px-36 py-12 sm:flex-row sm:items-center dark:bg-[var(--light-grayscale-charcoal)]">
      <span className="text-subheadline-sm font-bold sm:text-subheadline-lg sm:font-bold">
        Contract Expiring:
      </span>
      <div className="flex flex-col items-start justify-start gap-32 xs:flex-row xs:items-center">
        {KEYS.map(({ color, text }: Key) => (
          <div key={text} className="flex items-center gap-10">
            <div
              className={clsx('h-20 w-20 border border-solid border-grayscale-gray/25', color)}
            ></div>
            <span className="text-description-lg font-medium sm:text-subheadline-sm sm:font-medium">
              {text}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default TableKey;
